import { Backpack, Users, Plane, Handshake } from 'lucide-react';

const audiences = [
  { icon: Backpack, title: 'Solo, or a first big trip', text: 'Useful if you’re travelling on your own and would rather not leave anything important to memory.' },
  { icon: Users, title: 'Families', text: 'Useful if one person usually holds the whole checklist: documents, medications, everyone’s bits.' },
  { icon: Plane, title: 'Frequent flyers', text: 'Useful if trips repeat and you’d rather reuse a list you trust than rebuild one each time.' },
  { icon: Handshake, title: 'Shared trips', text: 'Useful if you’re going with others and packing, documents and spending need to stay together.' },
];

export const HomeWhoItsFor = () => (
  <section id="who-its-for" className="home-container home-whoitsfor" aria-labelledby="who-its-for-title">
    <div className="home-whoitsfor-heading">
      <div>
        <p className="home-eyebrow">Who it's for</p>
        <h2 id="who-its-for-title" className="home-section-title">Made for the way<br />you travel.</h2>
      </div>
      <p className="home-whoitsfor-lede">Anyone going somewhere can start free. These are the travelers who tend to get the most from it.</p>
    </div>
    <div className="home-whoitsfor-grid">
      {audiences.map(({ icon: Icon, title, text }) => (
        <div key={title} className="home-whoitsfor-card">
          <div className="home-whoitsfor-card-head">
            <Icon className="h-6 w-6 shrink-0 text-primary" strokeWidth={1.6} aria-hidden="true" />
            <h3>{title}</h3>
          </div>
          <p>{text}</p>
        </div>
      ))}
    </div>
    <p className="home-whoitsfor-note">Not on the list? If you’re simply going somewhere, the pack covers the same checks.</p>
  </section>
);
